import React from 'react'
import FAQComponent from './components/FaqComponent/FaqComponent.component'
import { SeoHead } from '@components/SeoHead/SeoHead.component'
import { useTranslation } from 'react-i18next'
import { getLanguageBasedOnDomain } from '@utils/getDomainExtension'

const Help = () => {
    const { i18n } = useTranslation()
    const seoLang = i18n.getFixedT(getLanguageBasedOnDomain())
    return (
        <div>
            <SeoHead title={seoLang('seo.pages.helpTitle')} description={seoLang('seo.pages.helpDescription')} />
            <FAQComponent />
        </div>
    )
}

export default Help
